import Radio from "backbone.radio";
import { nextTick } from "common/utils";
import getYear from "date-fns/getYear";
import moment from "moment";
import { createRef, Component } from "react";
import classNames from "classnames";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/pro-solid-svg-icons";

export class QuarterCalendar extends Component {
    static defaultProps = {
        currentYear: getYear(new Date())
    };
    
    constructor(props) {
        super(props);
        this.scrollableContainerRef = createRef();
    }
    
    componentDidMount() {
        this.centerRangeInView();
    }
    
    processQuarterClick = (date, { locked, future }) => (e) => {
        e.preventDefault();
        if (future) return;
    
        if (locked) {
            Radio.channel("main").request("show:package:compare");
            return;
        }
        
        this.props.selectDate(date);
    };
    
    isStartQuarter(year, quarter) {
        return this.props.startDate && year === this.props.startDate.year() && quarter === this.props.startDate.quarter();
    }
    
    isEndQuarter(year, quarter) {
        return this.props.endDate && year === this.props.endDate.year() && quarter === this.props.endDate.quarter();
    }
    
    isBetween(year, quarter) {
        return (this.props.startDate && this.props.endDate)
            && moment.utc().year(year).quarter(quarter).isBetween(this.props.startDate, this.props.endDate, "quarters", "[]");
    }
    
    centerRangeInView() {
        nextTick(() => {
            try {
                const parentOffset = this.scrollableContainerRef.current.offsetTop;
                const targetOffset = this.scrollableContainerRef.current.querySelector(".quarter.start").offsetTop;
    
                this.scrollableContainerRef.current.scrollTop = targetOffset - parentOffset;
            } catch {
                // Noop. We should not error here because running the op in nextTick.
            }
        });
    }
    
    renderQuarter(year, quarter) {
        const momentQuarter = moment.utc().year(year).quarter(quarter);
        const quarterAnalysis = {
            start: this.isStartQuarter(year, quarter),
            end: this.isEndQuarter(year, quarter),
            selected: this.isBetween(year, quarter),
            available: this.props.isPermittedDate(momentQuarter),
            get locked() {
                return !this.available;
            },
            get disabled() {
                return !this.available;
            },
            future: momentQuarter.isAfter(moment.utc().endOf("quarter")) || momentQuarter.clone().startOf("quarter").isAfter(this.props.maxDate)
        };
        
        return (
            <div
                className={classNames("quarter", quarterAnalysis)}
                key={`${year}-${quarter}`}
                onClick={this.processQuarterClick(momentQuarter.clone(), quarterAnalysis)}
            >
                {quarterAnalysis.locked && <span className="lock-icon"><FontAwesomeIcon icon={faLock}/></span>}
                <div className="q-number">{`Q${momentQuarter.quarter()}`}</div>
                <div className="range">{momentQuarter.clone().startOf("quarter").format("MMM D")} - {momentQuarter.clone().endOf("quarter").format("MMM D")}</div>
            </div>
        );
    }
    
    renderYear(year) {
        return (
            <div className="year" key={year}>
                <div className="quarterly-header">{year}</div>
                <div className="quarterly-year-row">
                    {Array.from({ length: 4 }).fill(null).map((item, index) => this.renderQuarter(year, index + 1))}
                </div>
            </div>
        );
    }
    
    render() {
        return (
            <div className="quarterly" ref={this.scrollableContainerRef}>
                {this.renderYear(this.props.currentYear - 1)}
                {this.renderYear(this.props.currentYear)}
            </div>
        );
    }
}
